import React from "react";
import {COMMON_TRANSLATIONS, ROUTES} from "../utils/constants";

import IconDownload from "../assets/icon-download.svg";
import IconDownloadDark from "../assets/icon-download-dark.svg";

const DownloadButton = ({ withMargin = false }) => {
  const selectedLang = typeof window !== "undefined" ? window.localStorage.getItem("lang") || "en" : "en";
  return (
    <a className={`btn-download btn-login ${withMargin ? "mr" : ""}`} href={ROUTES.login}>
      <span>{COMMON_TRANSLATIONS[selectedLang].login}</span>
      <img src={IconDownload} alt="" className="light"/>
      <img src={IconDownloadDark} alt="" className="dark"/>
    </a>
  );
};

export default DownloadButton;
